<input class="input"
    type="text"
    [attr.disabled]="disabled ? '' : null"
    [attr.readonly]="readonly"
    [attr.value]="value"
    [attr.placeholder]="placeholder"
>
